export const GHOST_ID_POSTFIX = "_ghost";
